export default __webpack_public_path__ + "static/media/attention_2.7d1ee030.svg";